module.exports = __webpack_public_path__ + "static/technology-implementation-banner-overlay-53d836a4963bacf6a0f8502bb3fdf5f3.jpg";